import dayjs from "dayjs";

import {
    fullMonthDayAndYear,
    serverResponseFormat,
    shortMonthAndDay,
    shortMonthDayAndYear,
} from "@similarweb/pro-logic-components";

// eslint-disable-next-line import/no-named-as-default
import DurationService from "app/services/DurationService";

type DateInput = string | number | Date | dayjs.Dayjs | null | undefined;

export class DateFormatter {
    static format(date: DateInput, format: string): string {
        const parsedDate = this.parseDate(date);
        if (parsedDate === null) {
            return "N/A";
        }

        return parsedDate.format(format);
    }

    static toShortDate(date: DateInput): string {
        return this.format(date, shortMonthDayAndYear);
    }

    static toFullDate(date: DateInput): string {
        return this.format(date, fullMonthDayAndYear);
    }

    static toShortMonthDay(date: DateInput): string {
        return this.format(date, shortMonthAndDay);
    }

    static parseDurationToDateRange(duration: string, format: string | "ISO"): { from: string; to: string } {
        const today = dayjs();

        const getDateFormatted = (date: dayjs.Dayjs): string => {
            return format === "ISO" ? date.toISOString() : date.format(format || serverResponseFormat);
        };

        if (duration?.includes("-")) {
            const [from, to] = duration.split("-");
            return {
                from: getDateFormatted(dayjs(from.replace(/\./g, "-"))),
                to: getDateFormatted(dayjs(to.replace(/\./g, "-"))),
            };
        }

        const parsed = DurationService.parsedDurationParam(duration) as { unit: string; count: number };
        const from = today.subtract(parsed.count, parsed.unit === "D" ? "day" : "month");
        return {
            from: getDateFormatted(from),
            to: getDateFormatted(today),
        };
    }

    private static parseDate(date: DateInput): dayjs.Dayjs | null {
        if (date === null || date === undefined) {
            return null;
        }

        const parsedDate = dayjs(date);

        return parsedDate.isValid() ? parsedDate : null;
    }
}
